import {
  error,
  tabaPayError,
  VerifyCardActionScreenFragment,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const AddExternalCard = gql`
  mutation AddExternalCard(
    $idempotencyId: IdempotencyToken!
    $input: AddExternalCardInput!
  ) {
    addExternalCard(idempotencyId: $idempotencyId, input: $input) {
      ... on AddExternalCardResultSuccess {
        externalCardId
        verifyCardActionScreen {
          ...verifyCardActionScreen
        }
        __typename
      }
      ... on AddExternalCardResultError {
        ...error
        __typename
      }
      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
    }
  }
  ${error}
  ${tabaPayError}
  ${VerifyCardActionScreenFragment}
`;
export default AddExternalCard;
